(function(angular, module) {var DebouncerFactory,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

DebouncerFactory = function($q, $timeout) {
  'ngInject';
  var Debouncer;
  Debouncer = (function() {
    function Debouncer(func, delay) {
      this.resolve = bind(this.resolve, this);
      this.call = bind(this.call, this);
      this.func = func;
      this.delay = delay;
      this.timeoutPromise = null;
      this.deferred = null;
    }

    Object.defineProperties(Debouncer.prototype, {
      promise: {
        get: function() {
          if (this.deferred != null) {
            return this.deferred.promise;
          } else {
            return $q.reject();
          }
        }
      }
    });

    Debouncer.prototype.call = function() {
      this.deferred = this.deferred || $q.defer();
      $timeout.cancel(this.timeoutPromise);
      this.timeoutPromise = $timeout(this.resolve, this.delay);
      return this.promise;
    };

    Debouncer.prototype.resolve = function() {
      var deferred;
      deferred = this.deferred;
      this.deferred = null;
      return $q.when(this.func()).then(function(result) {
        deferred.resolve(result);
        return result;
      });
    };

    return Debouncer;

  })();
  return Debouncer;
};

module.factory('Debouncer', DebouncerFactory);
})(angular, angular.module("dyb.util"));